import { WidgetProps } from "@rjsf/core";
import React from "react";

interface IBaseInput extends WidgetProps {
  type?: string
}

const BaseInput = (props: IBaseInput) => {

  const {
    placeholder,
    value,
    formContext
  } = props

  return <div>{value || placeholder || formContext.emptyValue}</div>
}

BaseInput.defaultProps = {
  type: "text",
  required: false,
  disabled: false,
  readOnly: false,
  autoFocus: false,

};

export default BaseInput;
